module.exports = __webpack_public_path__ + "static/img/c000.06fe9b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/c000.png
// module id = 2bHF
// module chunks = 18